import { TextField } from "../controlled-form/TextField";
import { translate } from "@kaltura/ds-react-utils";
import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { useFormContext } from "react-hook-form";

export interface NameFieldProps {
    id?: string;
    label?: string;
    className?: string;
}

const StyledTypography = styled(
    Typography,
    {
        shouldForwardProp(propName) {
            return !["isVisible"].includes(propName.toString());
        },
    }
)<{ isVisible?: boolean }>(({ theme, isVisible }) => ({
    color: theme.kaltura.palette.danger.main,
    marginTop: theme.spacing(1),
    display: "block",
    visibility: isVisible ? "visible" : "hidden",
}));

/**
 * Name field for add-new-menu modals forms
 */
export const NameField = (props: NameFieldProps) => {
    const { id = "name", label = translate("Name"), className = "kms-ds-form-name" } = props;

    const { formState } = useFormContext();
    const { errors } = formState;

    return (
        <div className={className}>
            <TextField
                label={label}
                id={id}
                required={true}
                fontWeightBold={true}
                inline={true}
                defaultValue=""
                ariaDescribedBy="name-error"
                registerOptions={{
                    required: translate("This field is required"),
                    maxLength: {
                        value: 255,
                        message: translate("Name cannot exceed 255 characters"),
                    },
                }}
            />
            <StyledTypography
                id="name-error"
                variant={"formError"}
                className={`${className}-error`}
                role="alert"
                aria-live="assertive"
                isVisible={!!errors.name}
            >
                {errors.name ? (errors.name.message as string) : " "}
            </StyledTypography>
        </div>
    );
};
